import React from 'react'
import { Link, LinkProps } from 'react-router-dom'
import useReferenceStore from '../state/useReferenceStore'

type Props = Omit<LinkProps, 'to'> & {
  character: wowaudit.CharacterReference
}

// Several characters can share a path after renames, so the clicked reference is stored for the dashboard to load by ID.
const CharacterLink = React.forwardRef<HTMLAnchorElement, Props>(
  ({ character, onClick, ...props }, ref) => (
    <Link
      ref={ref}
      to={character.path}
      onClick={(event) => {
        useReferenceStore.getState().storeReferences([character])
        onClick?.(event)
      }}
      {...props}
    />
  ),
)
CharacterLink.displayName = 'CharacterLink'

export default CharacterLink
